import React from "react";
import { renderBoldText } from "../utils/helper";
import { Grid2 as Grid } from "@mui/material";
import { CalendarMonthOutlined, EmailOutlined } from "@mui/icons-material";
import { blue, green } from "@mui/material/colors";
import { useGlobalModalContext } from "../context/GlobalModalContext";
import EmailMeetingMinuteDialog from "../components/Modal/EmailMeetingMinuteDialog";
import MeetingSchedulerDialog from "../components/Modal/MeetingSchedulerDialog";

function NotiCard({ data }) {
  // console.log('focus areas', JSON.stringify(focusAreas))
  const { showModal, hideAllModal, hideModal } = useGlobalModalContext();
  
  const handleEmail = (data) => {
    showModal(<EmailMeetingMinuteDialog emails={data.participant_emails} />);
  };

  const handleScheduler = (data) => {
    showModal(<MeetingSchedulerDialog emails={data.participant_emails} />);
  };
  return (
    <div className="bg-white">
      {/* <h2 className="text-lg font-bold mb-2 text-main">INDUSTRY REGULATIONS</h2> */}
      <ul>
        {data?.map((item, index) => (
          <li key={index} className="pb-4">
            <div
              className="text-xs border rounded px-4 py-4"
              style={{
                borderColor: "#A6A6A6",
                borderLeft: "4px solid #A6A6A6",
              }}
            >
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div className="font-bold px-2">{item.client} </div>
                <div color="blue">
                  <EmailOutlined fontSize="medium" sx={{ color: "#00555C" }} onClick={() => handleEmail(item)} />
                  <CalendarMonthOutlined
                    fontSize="medium"
                    sx={{ color: "#00555C" }}
                    onClick={() => handleScheduler(item)}
                  />
                </div>
              </Grid>

              <div>
                {/* <SentimentFlag sentimentFlag={item.sentiment_flag} /> */}
                {item.title && (
                  <span className="font-bold text-base px-2">
                    {item.title} :{" "}
                  </span>
                )}
              </div>
              <div className="px-2">{renderBoldText(item.description)}</div>
              {item.due_date && (
                <div className="p-2 pt-2 font-light">
                  due date: {item.due_date}
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default NotiCard;
